import Vue from "vue";
import store from "@/store";
import { setup } from "@/modules/logger";
import PageError from "@/views/PageError.vue";

export function getApp(error: Error) {
  Vue.use(setup, { store });
  return Vue.extend({
    store,
    render: h => h(PageError, { props: { error } }),
  });
}
export function createErrorApp(error: Error) {
  return new (getApp(error))();
}
